<template>
    <v-layout v-if="initialising"></v-layout>
    <v-layout v-else wrap :class="{'ma-4': $vuetify.breakpoint.smAndUp}">
        <v-dialog ref="confirmDlg"
                  v-model="showConfirm"
                  max-width="300px">
            <v-card v-if="showConfirm">
                <v-toolbar dense dark flat :color="confirmDlgConsts[confirmDlgType].color">
                    <v-icon dark>{{confirmDlgConsts[confirmDlgType].icon}}</v-icon>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>{{confirmDlgConsts[confirmDlgType].title}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon color="transparent">{{confirmDlgConsts[confirmDlgType].icon}}</v-icon>
                </v-toolbar>
                <v-layout pa-4>
                    {{confirmDlgConsts[confirmDlgType].text}}
                </v-layout>
                <v-layout px-5 pb-5 justify-space-between>
                    <v-btn color="secondary" dark @click="confirmFromDlg">
                        {{confirmDlgConsts[confirmDlgType].accept || 'Continue'}}
                    </v-btn>
                    <v-btn color="error" text @click="showConfirm = false">
                        Cancel
                    </v-btn>
                </v-layout>
            </v-card>
        </v-dialog>
        <v-dialog ref="hintDlg"
                  v-model="showHint"
                  max-width="60%"
                  :fullscreen="$vuetify.breakpoint.xs">
            <v-card v-if="hint">
                <v-toolbar dense dark flat color="primary">
                    <v-btn v-if="$vuetify.breakpoint.xs" text color="error" @click="showHint = false">close</v-btn>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>
                        <v-icon dark>help</v-icon>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-layout mb-4>
                    <component :is="hintComponents[hint]"></component>
                </v-layout>
                <v-layout px-5 pb-5 justify-space-between>
                    <v-btn color="secondary" dark @click="showHint=false">
                        Ok
                    </v-btn>
                </v-layout>
            </v-card>
        </v-dialog>
        <v-flex xs12>
            <p class="display-1 text-center mt-3 mb-1"><span class="font-weight-light">Subscription for </span>{{stopName}}</p>
        </v-flex>
        <v-form ref="form" lazy-validation class="flex xs12">
            <v-layout wrap align-center>
                <v-flex xs12 class="subtitle-2 font-weight-light font-italic mb-2 ma-1 d-flex justify-end">
                    Tap on <v-icon size="20" class="ml-1">help</v-icon> for help
                </v-flex>
                <v-flex xs12 class="title font-weight-light mb-n2 ma-1 d-flex align-center">
                    Select a route
                    <v-icon @click="hint='Routes'" class="ml-1">help</v-icon>
                </v-flex>
                <v-flex xs12 sm4 d-flex pa-1>
                    <v-autocomplete :items="projects"
                                    v-model="subscription.projectTag"
                                    label="Company"
                                    single-line
                                    light
                                    :readonly="projects.length <= 1"
                                    class="pt-0"
                                    @change="dirtyTripScheduleTag"></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm8 d-flex pa-1>
                    <v-scroll-y-transition>
                        <v-autocomplete v-if="valid.project"
                                        :items="routes"
                                        v-model="route"
                                        label="Route"
                                        single-line
                                        light
                                        return-object
                                        class="pt-0"
                                        @change="dirtyRouteNo"></v-autocomplete>
                    </v-scroll-y-transition>
                </v-flex>
                <v-flex xs12 sm8 offset-sm4 d-flex pa-1>
                <!--<v-flex xs12 sm8 d-flex pa-1 align-center>-->
                    <v-scroll-y-transition>
                        <v-autocomplete v-if="valid.route && destinations"
                                        :items="destinations"
                                        v-model="subscription.destination"
                                        label="Destination"
                                        single-line
                                        light
                                        class="pt-0"
                                        @change="dirtyDest"></v-autocomplete>
                    </v-scroll-y-transition>
                </v-flex>
                <v-layout wrap xs12 align-center>

                    <v-flex xs12 sm4 d-flex pa-1 align-center></v-flex>
                    <!-----------------------------Start of Trip table-------------------------------------------------->
                    <v-flex xs12 sm8 d-flex pa-1 align-self-center v-if="valid.dest">
                        <v-dialog ref="timetableDlg"
                                  v-model="showTimetable"
                                  max-width="60%"
                                  :fullscreen="$vuetify.breakpoint.xs">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn 
                                       light
                                       small
                                       class="m1-1"
                                       v-bind="attrs"
                                       v-on="on"
                                       @click="getTimetable">
                                    timetable
                                </v-btn>
                            </template>
                            <v-card>
                                <v-toolbar color="primary" dark flat>
                                    <v-btn text color="error" @click="showTimetable = false">close</v-btn>
                                    <v-toolbar-title v-if="!timetableDest || !timetableLoaded"><v-icon>event_note</v-icon></v-toolbar-title>
                                    <v-tabs v-else
                                            v-model="timetableServiceNo"
                                            align-with-title
                                            background-color="transparent"
                                            style="width:auto">
                                        <v-tabs-slider></v-tabs-slider>

                                        <v-tab v-for="svc in timetableDest.Services" :key="timetableDest.Services.indexOf(svc)">
                                            {{svc.Name}}
                                        </v-tab>
                                    </v-tabs>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-title v-if="!$vuetify.breakpoint.xs">Timetable for {{subscription.routeNo + (subscription.routeNo && subscription.routeName ? ". " : "") + subscription.routeName }}</v-toolbar-title>
                                    <v-spacer v-if="!$vuetify.breakpoint.xs"></v-spacer>
                                    <v-toolbar-title v-if="!$vuetify.breakpoint.xs">{{ subscription.destination}}</v-toolbar-title>
                                </v-toolbar>
                                <v-layout pa-12 align-center justify-center v-if="failedTimetableIds.some(x => containsObject(subscription, x))">
                                    <v-alert type="error" border="bottom">
                                        Could not retrieve a timetable for this route
                                    </v-alert>
                                </v-layout>
                                <v-layout pa-12 align-center justify-center v-else-if="!timetableLoaded">
                                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                                </v-layout>
                                <v-layout v-else>
                                    <v-tabs-items v-model="timetableServiceNo" style="min-width:100%" :touchless="true">
                                        <v-tab-item v-for="svc in timetableDest.Services" :key="timetableDest.Services.indexOf(svc)" style="max-height:80vh;overflow:auto">
                                            <v-simple-table v-for="(ttGroup, i) in svc.Groups"
                                                            :key="i"
                                                            dense
                                                            light
                                                            class="text-center">
                                                <thead>
                                                    <tr>
                                                        <th v-for="(ttPlatform, j) in getTimetableGrpHeaders(ttGroup)"
                                                            :key="j"
                                                            :class="{'text-center':true, 'pink lighten-4':ttPlatform.isThis}">
                                                            {{ttPlatform.name}}

                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(ttTrip, k) in getTimetableGrpTimes(ttGroup)" :key="k">
                                                        <td v-for="(ttMinute, m) in ttTrip" :key="m" :class="{'pink lighten-4':ttMinute.isThis}">
                                                            {{ ttMinute.t ? (m ? toAmPm(~~(ttMinute.t / 60) + ':' + ttMinute.t % 60).slice(0, -3) : toAmPm(~~(ttMinute.t / 60) + ':' + ttMinute.t % 60)) + (ttMinute.approx ? '*' : '') : '-'}}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </v-simple-table>
                                        </v-tab-item>
                                    </v-tabs-items>
                                </v-layout>
                                <!--<v-layout align-center justify-end px-4 style="height:10vh">
                                    <v-btn text color="error" @click="showTimetable = false">Close</v-btn>
                                </v-layout>-->
                            </v-card>
                        </v-dialog>
                    </v-flex>
                    <!-----------------------------End of Trip table-------------------------------------------------->

                </v-layout>

                <v-flex xs12 class="title font-weight-light mb-n2 mt-2">
                    <v-scroll-y-transition>
                        <v-layout column v-if="valid.dest">
                            <v-divider></v-divider>
                            <span class="ma-1 d-flex align-center">
                                When do you want to be notified?
                                <v-icon @click="hint='Times'" class="ml-1">help</v-icon>
                            </span>
                        </v-layout>
                    </v-scroll-y-transition>
                </v-flex>

                <v-flex xs12 py-2>
                    <v-scroll-y-transition>
                        <v-layout column v-if="valid.route&&valid.dest">
                            <v-list light>
                                <v-list-item-group v-model="notifTimeType" mandatory color="primary">
                                    <v-list-item :class="{'pl-2':$vuetify.breakpoint.xs}">
                                        <v-list-item-icon :class="{'align-self-center':true, 'mr-3':$vuetify.breakpoint.xs}">
                                            <v-icon>timelapse</v-icon>
                                        </v-list-item-icon>
                                        <v-layout wrap xs12 align-center>
                                            <v-flex xs4 sm2>
                                                Between
                                            </v-flex>
                                            <v-flex xs8 sm4>
                                                <v-dialog ref="afterTimeDlg"
                                                          v-model="showAfterTime"
                                                          :return-value.sync="subscription.notBefore"
                                                          width="290px">
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field v-model="afterTime"
                                                                      label="Pick a time"
                                                                      prepend-icon="access_time"
                                                                      readonly
                                                                      :disabled="!!notifTimeType"
                                                                      @click:prepend="on.click()"
                                                                      v-on="on"></v-text-field>
                                                    </template>
                                                    <v-time-picker v-if="showAfterTime"
                                                                   v-model="subscription.notBefore"
                                                                   full-width
                                                                   :max="subscription.notAfter"
                                                                   @change="$refs.afterTimeDlg.save(subscription.notBefore) || (showAfterTime = false)">
                                                        <v-spacer></v-spacer>
                                                        <v-btn text color="error" @click="showAfterTime = false">Cancel</v-btn>
                                                        <v-btn text color="primary" @click="$refs.afterTimeDlg.save(subscription.notBefore)">OK</v-btn>
                                                    </v-time-picker>
                                                </v-dialog>
                                            </v-flex>
                                            <v-flex class="text-center" xs4 sm1>
                                                and
                                            </v-flex>
                                            <v-flex xs8 sm4>
                                                <v-dialog ref="beforeTimeDlg"
                                                          v-model="showBeforeTime"
                                                          :return-value.sync="subscription.notAfter"
                                                          width="290px">
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field v-model="beforeTime"
                                                                      label="Pick a time"
                                                                      prepend-icon="access_time"
                                                                      readonly
                                                                      :disabled="!!notifTimeType"
                                                                      @click:prepend="on.click()"
                                                                      v-on="on"></v-text-field>
                                                    </template>
                                                    <v-time-picker v-if="showBeforeTime"
                                                                   v-model="subscription.notAfter"
                                                                   full-width
                                                                   :min="subscription.notBefore"
                                                                   @change="$refs.beforeTimeDlg.save(subscription.notAfter) || (showbeforeTime = false)">
                                                        <v-spacer></v-spacer>
                                                        <v-btn text color="error" @click="showBeforeTime = false">Cancel</v-btn>
                                                        <v-btn text color="primary" @click="$refs.beforeTimeDlg.save(subscription.notAfter)">OK</v-btn>
                                                    </v-time-picker>
                                                </v-dialog>
                                            </v-flex>
                                        </v-layout>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>
                        </v-layout>

                    </v-scroll-y-transition>
                </v-flex>
                <v-flex xs12 class="title font-weight-light mb-n2 mt-2">
                    <v-scroll-y-transition>
                        <v-layout column v-if="valid.dest&&valid.trip">
                            <v-divider></v-divider>
                            <span class="ma-1 d-flex align-center">
                                On what days?
                                <v-icon @click="hint='Dates'" class="ml-1">help</v-icon>
                            </span>
                        </v-layout>
                    </v-scroll-y-transition>
                </v-flex>
                <v-flex xs12 py-2>
                    <v-scroll-y-transition>
                        <v-layout column v-if="valid.dest&&valid.trip">
                            <v-btn-toggle v-model="weekdayBtns"
                                          multiple class="justify-stretch flex xs12"
                                          ref="weekdayEl"
                                          @change="blurFromRef('weekdayEl')">
                                <v-btn text
                                       v-for="day in theWeek"
                                       :key="day"
                                       :disabled="notifTimeType === 1 && tripInfo && tripInfo.Days && !tripInfo.Days.includes(day)"
                                       class="flex-grow-1 flex-shrink-1"
                                       style="min-width:40px;"
                                       color="primary">
                                    {{$vuetify.breakpoint.xs ? day.slice(0,1) : day.slice(0,3)}}
                                </v-btn>
                            </v-btn-toggle>
                            <v-layout class="justify-center" style="font-size:1.5em">
                                <DateRangePicker v-model="date"></DateRangePicker>
                            </v-layout>
                        </v-layout>
                    </v-scroll-y-transition>
                </v-flex>
                <v-flex xs12 class="title font-weight-light mb-n2 mt-2">
                    <v-scroll-y-transition>
                        <v-layout column v-if="valid.dest&&valid.days">
                            <v-divider></v-divider>
                            <span class="ma-1 d-flex align-center">
                                How many minutes warning?
                                <v-icon @click="hint='Warning'" class="ml-1">help</v-icon>
                            </span>
                        </v-layout>
                    </v-scroll-y-transition>
                </v-flex>
                <v-flex xs12 py-2>
                    <v-scroll-y-transition>
                        <v-flex class="d-flex align-center"
                                xs12
                                v-if="valid.dest&&valid.days">
                            <v-flex xs3 sm4 class="text-right pr-3">Warn me</v-flex>
                            <v-flex xs3 sm4>
                                <v-text-field v-model="subscription.warningTime"
                                              ref="warningTimeField"
                                              :rules="minuteRules"
                                              required
                                              type="number"
                                              suffix="min"
                                              :class="centered-input"
                                              color="primary"></v-text-field>
                                              <!--@input="getTimetable"-->
    
                            </v-flex>
                            <v-flex xs6 sm4 class="pl-3">before the the ETA</v-flex>
                        </v-flex>
                    </v-scroll-y-transition>
                </v-flex>
                <!------------------ start of filtered available trips------------------------------>
                <v-flex xs12 class="title font-weight-light mb-n2 mt-2">
                    <v-scroll-y-transition>
                        <v-layout column v-if="valid.route&&valid.dest&&valid.warning">
                            <v-divider></v-divider>
                            <span class="ma-1 d-flex align-center">
                                You will receive notifications for all trips within the time range below
                                <v-icon @click="hint='FilteredTrips'" class="ml-1">help</v-icon>
                            </span>
                        </v-layout>
                    </v-scroll-y-transition>
                </v-flex>
                <v-flex xs12 py-2 v-if="valid.route&&valid.dest&&valid.warning" v-model="subscribedTrips">
                    <v-layout v-if="!hasSubscribedTrips">
                        <v-alert type="error" border="bottom">
                            No available trips in selected time range. Please refer to timetable.
                        </v-alert>
                    </v-layout>
                    <!--<v-layout pa-12 align-center justify-center v-else-if="!timetableLoaded">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-layout>-->
                    <v-layout v-else>
                        <v-simple-table dense
                                        light
                                        style="border: 1px solid;border-color:grey;"
                                        multiple class="justify-stretch flex xs12 elevation-1">
                            <thead>
                                <tr style="background-color:#e2e7ed;">
                                    <th>
                                    </th>
                                    <th v-for="(day, j) in theWeek"
                                        :key="j"
                                        :class="{'text-center':true, 'lighten-4':true}"
                                        style="min-width:40px;color:#073662;">
                                        {{day.slice(0,3).toUpperCase()}}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td
                                    :class="{'text-center':true}">
                                        From
                                    </td>
                                    <td v-for="(trip, k) in subscribedTrips" :key="k" :class="{'text-center':true, 'lighten-4':true}">
                                        {{trip[0] != ''? trip[0] : '-'}}
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                    :class="{'text-center':true}">
                                        To
                                    </td>
                                    <td v-for="(trip, k) in subscribedTrips" :key="k" :class="{'text-center':true, 'lighten-4':true}">
                                        {{trip[1] != ''? trip[1] : '-'}}
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-layout>
                </v-flex>
                <!------------------ end of filtered available trips------------------------------>
                <v-flex xs12 class="title font-weight-light mb-n2 mt-2">
                    <v-scroll-y-transition>
                        <v-layout column v-if="valid.warning">
                            <v-divider></v-divider>
                            <span class="ma-1 d-flex align-center">
                                How do you want to receive notifications?
                                <v-icon @click="hint='Addresses'" class="ml-1">help</v-icon>
                            </span>
                        </v-layout>
                    </v-scroll-y-transition>
                </v-flex>
                <v-flex xs12 py-2>
                    <v-scroll-y-transition>
                        <v-layout column v-if="valid.warning">
                            <v-list light>
                                <v-list-item-group v-model="contactTypeModel" mandatory color="primary" class="d-flex flex-wrap">
                                    <v-list-item class="flex xs12 sm6"
                                                 v-for="(contact, i) in contactTypes"
                                                 :key="contact.name">
                                        <v-list-item-icon class="align-self-center mr-3">
                                            <v-icon>{{contactTypeConsts[contact.name].icon}}</v-icon>
                                        </v-list-item-icon>
                                        <v-layout>
                                            <v-flex class="align-self-center mr-3 flex-grow-0">{{contact.name}}:</v-flex>
                                            <component :is="contactTypeConsts[contact.name].component"
                                                       :type="contact"
                                                       v-model="contactModels[contact.name]"
                                                       :addresses="contactAddresses[contact.name]"
                                                       :disabled="i != contactTypeModel"
                                                       @change.prevent.stop="foo"></component>
                                        </v-layout>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>
                        </v-layout>
                    </v-scroll-y-transition>
                </v-flex>
                <v-flex xs12 column><v-divider></v-divider></v-flex>
                <v-layout xs12 mt-3 wrap :class="{'mx-2 mb-2':$vuetify.breakpoint.xs, 'flex':true}">
                    <v-flex xs6 sm4 align-center class="d-flex">
                        <v-btn type="submit" @click.prevent="saveAndExit" :disabled="!valid.all" color="primary">Save</v-btn>
                        <v-btn text color="error" @click="cancel">Cancel</v-btn>
                    </v-flex>
                    <v-flex xs12 sm4 :class="{'order-first':$vuetify.breakpoint.xs, 'd-flex':true}" justify-center>
                        <v-switch ref="notificationToggleEl"
                                  :disabled="!valid.all"
                                  v-model="subscription.enabled"
                                  label="Turn notifications on"
                                  color="success"
                                  @change="notificationToggle($event)"></v-switch>
                    </v-flex>
                    <v-flex xs6 sm4 justify-end class="d-flex" align-center>
                        <v-btn color="error" @click="makeConfirmDialog('delete')">
                            <v-icon class="mr-1 ml-n1">delete</v-icon>Delete
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-layout>
</v-form>
        <v-progress-linear indeterminate color="secondary" :active="showLoading"></v-progress-linear>
    </v-layout>
</template>
<script>
    import axios from '../plugins/axios';
    import { Promise } from 'core-js';
    import hintComponents from "./hints/hints.js";

    const theWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const confirmDlgConsts = {
        cancel: {
            icon: 'warning',
            color: 'warning',
            title: 'Cancel?',
            text: 'Are you sure you want to return? Your changes will not be saved',
            accept: 'OK'
        },
        notifs: {
            icon: 'warning',
            color: 'success',
            title: 'Turn on notifications',
            text: 'Are you sure you want to turn on notifications? You will receive weekly messages at the times you have chosen.',
            accept: 'Yes'
        },
        delete: {
            icon: 'delete',
            color: 'error',
            title: 'Delete stop?',
            text: 'Are you sure you want to delete this stop from your watch list? To disable notifications but remember these settings you can de-select "Turn notifications on" instead',
            accept: 'Delete'
        }
    };
    const contactTypeConsts = {
        'Email': {
            icon: 'email',
            component: () => ({ component: import("./ContactEmail.vue") }),
            componentName: "ContactEmail",
        },
        'SMS': {
            icon: 'textsms',
            component: () => ({ component: import("./ContactSms.vue") }),
            componentName: "ContactSms",
        },
    };

    export default {
        components: {
        },
        props: {
            model: Object
        },
        data() {
            return {
                // values initialised by model, must be reassigned when model changes (see `watch`/`created` section below)
                initialising: true,
                subscription: null,
                notifTimeType: 0,
                contactModels: null,
                contactTypeModel: 0,
                dateData: {
                    start: null,
                    end: null
                },
                explicitNotifState: false,

                // consts and empty initialisations, don't worry about re-initialisation
                showScheduleIcon: false,
                showAfterTime: false,
                showBeforeTime: false,
                showTimetableBase: false,
                timetableData: null,
                tripInfo: null,
                disabledDays: [],
                timetableId: null,
                failedTimetableIds: [],
                timetableServiceNo: null,
                timetableLoaded: false,
                minuteRules: [
                    (v) => !!v || 'Field is required',
                    (v) => /^\d+$/.test(v) || 'Only whole numbers are allowed',
                    (v) => +v <= this.maxArrivalScopeMin || 'Maximum allowed time is ' + this.maxArrivalScopeMin + ' minutes',
                ],
                theWeek,
                showConfirm: false,
                confirmDlgConsts,
                confirmDlgType: 'notifs',
                showLoading: false,
                newModel: false,
                contactTypeConsts,
                hint: null,
                hintComponents,
                availableProjects: [],
                hasSubscribedTrips: false,
                platformData: [],
                maxArrivalScopeMin: 60,
                stopName: '',
                platformDataLoaded:false,
            }
        },
        computed: {
            contactTypes() {
                return this.$store.state.contactMethods;
            },
            contactAddresses() {
                var addrSet = {};
                for (let addr of this.$store.state.contactAddresses) {
                    addrSet[addr.contactMethod.name] = addrSet[addr.contactMethod.name] || [];
                    addrSet[addr.contactMethod.name].push({
                        contactAddressId: addr.contactAddressId,
                        address: addr.address,
                    });
                }
                for (let method of this.contactTypes) {
                    addrSet[method.name] = addrSet[method.name] || [];
                    addrSet[method.name].sort((a, b) => b.contactAddressId - a.contactAddressId); //contactAddressId is created incrementally, so biggest -> smallest is most recent first
                }
                return addrSet;
            },
            projects() {
                this.availableProjects = this.platformData;
                var projects = this.platformData.map(x => { return { text: x.Name, value: x.Tag } });
                this.platformDataLoaded = true;
                return projects;
            },
            routes() {
                var proj = this.availableProjects.find(x => x.Tag === this.subscription.projectTag);
                if (!proj) return []
                return proj.Routes.map(x => { return { no: x.No, name: x.Name, text: x.No + (x.No && x.Name ? " - " : "") + x.Name }; });
            },
            destinations() {
                var proj = this.availableProjects.find(x => x.Tag === this.subscription.projectTag);
                if (!proj) return null;
                var route = proj.Routes.find(x => x.No === this.subscription.routeNo && x.Name === this.subscription.routeName);
                if (!route) return null;
                var destSet = new Set();
                route.Destinations.forEach(x => x.Name && destSet.add(x.Name));
                if (destSet && destSet.size) {
                    return Array.from(destSet);
                }
                return undefined;
            },
            afterTime() {
                return this.notifTimeType === 0 ? this.subscription.notBefore && this.toAmPm(this.subscription.notBefore) : null;
            },
            beforeTime() {
                return this.notifTimeType === 0 ? this.subscription.notAfter && this.toAmPm(this.subscription.notAfter) : null;
            },
            route: {
                get() {
                    return this.routes.find(x => x.no == this.subscription.routeNo && x.name == this.subscription.routeName) || { no: '', name: '', text: '' };
                },
                set(v) {
                    this.subscription.routeNo = v.no;
                    this.subscription.routeName = v.name;
                }
            },
            showTimetable: {
                get() { return this.showTimetableBase; },
                set(v) {
                    this.showTimetableBase = v;
                    // this.getTimetable();
                }
            },
            subscribedTrips() {
                var proj = this.availableProjects.find(x => x.Tag === this.subscription.projectTag);
                if (!proj) return null;
                var route = proj.Routes.find(x => x.No === this.subscription.routeNo && x.Name === this.subscription.routeName);
                if (!route) return null;
                var timetableDest = route.Destinations.find(x => x.Name === this.subscription.destination);
                var notBefore = Number(this.subscription.notBefore.split(':')[0]) * 60 + Number(this.subscription.notBefore.split(':')[1]);
                var notAfter = Number(this.subscription.notAfter.split(':')[0]) * 60 + Number(this.subscription.notAfter.split(':')[1]);
                var tripDict = {};
                this.hasSubscribedTrips = false;
                for (let weekday of theWeek)
                    tripDict[weekday] = ['', ''];
                if (timetableDest  && timetableDest.Services) {
                    for (let service of timetableDest.Services) {
                        for (let day of this.subscription.weekdayNames) {
                            if (service.Days.includes(day)) {
                                var tripsWithinRange = [];
                                for (let grp of service.Groups) {
                                    var selIndex = grp.PlatformSelIndex;
                                    for (let index of selIndex) {
                                        for (let trip of grp.Trips) {
                                            if (notBefore + Number(this.subscription.warningTime) <= Number(trip.Minutes[index]) && notAfter + Number(this.subscription.warningTime) >= Number(trip.Minutes[index])) {
                                                this.hasSubscribedTrips = true;
                                                var time = this.toAmPm(~~(Number(trip.Minutes[index]) / 60) + ':' + Number(trip.Minutes[index]) % 60);
                                                tripsWithinRange.push(Number(trip.Minutes[index]));
                                            }
                                        }
                                    }
                                }
                                if (tripsWithinRange.length > 0) {
                                    tripsWithinRange.sort(function (a, b) { return a - b; });
                                    if (tripsWithinRange.length > 1) {
                                        tripDict[day] = [this.toAmPm(~~(tripsWithinRange[0] / 60) + ':' + (tripsWithinRange[0] % 60)), this.toAmPm(~~(tripsWithinRange[tripsWithinRange.length - 1] / 60) + ':' + (tripsWithinRange[tripsWithinRange.length - 1] % 60))];
                                    } else {
                                        tripDict[day] = [this.toAmPm(~~(tripsWithinRange[0] / 60) + ':' + (tripsWithinRange[0] % 60)), this.toAmPm(~~(tripsWithinRange[0] / 60) + ':' + (tripsWithinRange[0] % 60))];
                                    }
                                }
                            }
                        }
                    }
                }
                // console.log(tripDict);
                return tripDict;


            },
            timetableDest() {
                if (this.platformDataLoaded && this.availableProjects.length > 0 && this.subscription.projectTag && this.subscription.destination && this.subscription.routeNo) {
                    this.getTimetable();
                    var dest = this.timetableData && this.timetableData.Destinations && this.timetableData.Destinations.find(x => x.Name === this.subscription.destination)
                    if (dest && dest.Services)
                    {
                        return dest;
                    }
                }
                    return null;
            },
            valid() {
                const contactType = this.contactTypes[this.contactTypeModel];
                const validSteps = [
                    {
                        name: "project",
                        valid: !!this.subscription.projectTag
                    },
                    {
                        name: "route",
                        valid: this.subscription.routeName || this.subscription.routeNo
                    },
                    {
                        name: "dest",
                        valid: this.subscription.destination || typeof this.destinations === 'undefined'
                    },
                    {
                        name: "trip",
                        valid:
                            (
                                this.subscription.notBefore &&
                                this.subscription.notBefore != '00:00' &&
                                this.subscription.notAfter &&
                                this.subscription.notAfter != '23:59' &&
                                this.notifTimeType == 0
                            ) || (
                                this.subscription.tripScheduleTag &&
                                this.notifTimeType == 1
                            )
                    },
                    {
                        name: "days",
                        valid: this.subscription.weekdayNames.length > 0
                    },
                    {
                        name: "warning",
                        valid: this.subscription.warningTime &&
                            this.subscription.warningTime >= 0 &&
                            this.subscription.warningTime <= this.maxArrivalScopeMin &&
                            (
                                (
                                    this.$refs.warningTimeField &&
                                    this.$refs.warningTimeField.errorBucket.length === 0
                                ) ||
                                this.subscription.subscriptionId
                            )
                    },
                    {
                        name: "address",
                        valid: contactType &&
                            this.contactAddresses[contactType.name] &&
                            this.contactAddresses[contactType.name][this.contactModels[contactType.name]] &&
                            this.contactAddresses[contactType.name][this.contactModels[contactType.name]].contactAddressId
                    },
                    {
                        name: "subscribedTrips",
                        valid: this.hasSubscribedTrips
                    }
                ]
                var valid = {};
                for (let validator of validSteps) {
                    if (!validator.valid)
                        return valid;
                    valid[validator.name] = true;

                }
                if (!this.explicitNotifState)
                    this.subscription.enabled = true;
                valid.all = true;
                return valid;
            },
            weekdayBtns: {
                get() { return this.subscription.weekdayNames.map(x => this.theWeek.indexOf(x)); },
                set(v) { this.subscription.weekdayNames = v.map(x => this.theWeek[x]); }
            },
            date: {
                get() {
                    this.dateData.start = this.subscription.validFrom;
                    this.dateData.end = this.subscription.validTo;
                    return this.dateData;
                },
                set(v) {
                    v = v || { start: null, end: null };
                    this.dateData = v;
                    this.subscription.validFrom = v.start
                    this.subscription.validTo = v.end
                }
            },
            showHint: {
                get() { return !!this.hint },
                set(v) { if (!v) this.hint = null; }
            },

        },
        methods: {
            initialise(n) {
                this.platformDataLoaded = false;
                this.subscription = Object.assign({}, n);
                axios.get("api/subscriptions/PlatformSchedule?Tag=" + this.subscription.platformTag)
                    .then(response => {
                        this.platformData = response.data.Projects
                        this.maxArrivalScopeMin = response.data.MaxArrivalScopeMin
                        this.stopName = response.data.Name
                        console.log(this.platformData);
                        if (this.projects.length == 1)
                            this.subscription.projectTag = this.projects[0].value;
                        this.initialising = false;
                    })
                    .catch(error => console.log(error));
                this.notifTimeType = n.tripScheduleTag ? 1 : 0;
                this.contactModels = this.contactTypes.reduce((acc, val) => {
                    var idx = this.contactAddresses[val.name].findIndex(x => x.contactAddressId == n.contactAddressId);
                    acc[val.name] = idx < 0 ? 0 : idx;
                    return acc;
                }, {});
                this.contactTypeModel = (() => {
                    let idx = this.contactTypes.findIndex(x => this.contactAddresses[x.name].some(y => y.contactAddressId == n.contactAddressId));
                    return idx < 0 ? 0 : idx;
                })();

                //if (this.projects.length == 1)
                //    this.subscription.projectTag = this.projects[0].value;

                this.explicitNotifState = !n.localId;

              //  this.initialising = false;
            },
            toAmPm(str) {
                const [h, m] = str.split(":");
                return ((+h + 11) % 12 + 1) + ":" + m.padStart(2, '0') + (+h > 11 ? ' pm' : ' am')
            },
            containsObject(a, b) {
                if (!a || !b) return false;
                for (let prop of Object.getOwnPropertyNames(b)) {
                    if (prop.startsWith("_")) continue;
                    if (b[prop] === Object(b[prop]) && !this.containsObject(a[prop], b[prop])) return false;
                    if (a[prop] !== b[prop]) return false;
                }
                return true;
            },
            toggleTimetable() {
                this.showTimetable = true;
            },
            getTimetable() {
                //if (!this.containsObject(this.subscription, this.timetableId)) {
                this.timetableId = {
                    projectTag: this.subscription.projectTag,
                    routeNo: this.subscription.routeNo,
                    routeName: this.subscription.routeName
                };
                this.timetableData = null;
                this.timetableLoaded = false;
                var routes = this.availableProjects.find(x => x.Tag === this.subscription.projectTag)
                    .Routes
                    .find(r => r.No === this.subscription.routeNo && r.Name === this.subscription.routeName)
                if (routes) {
                    this.timetableData = routes;
                    this.timetableLoaded = true;
                }
                else {
                    console.log("Failed to retrieve timetable");
                    this.failedTimetableIds.push(this.timetableId);
                }
                //}
            },
            getTimetableGrpHeaders(grp) {
                var plats = grp.Platforms.map(x => { return { name: x, isThis: false, itTimepoint: true } });
                var selIndex = grp.PlatformSelIndex;
                for (var i = 0; i < grp.Platforms.length; i++) {
                    if (selIndex.some(e => e === i)) {
                        plats[i].isThis = true;
                        plats[i].name += ' (Your Stop)';
                    }
                }
                return plats;
            },


            getTimetableGrpTimes(grp) {
                var trips = grp.Trips.map(x => x.Minutes.map(y => { return { t: y, isThis: false, approx: false }; }));
                var selIndex = grp.PlatformSelIndex;
                for (let trip of trips) {
                    for (var i = 0; i < trip.length; i++) {
                        if (selIndex.some(e => e === i)) {
                            trip[i].isThis = true;
                        }
                    }
                }
                return trips;
            },

            makeConfirmDialog(t) {
                if (this.confirmDlgConsts[t]) {
                    this.confirmDlgType = t;
                    this.showConfirm = true;
                }
            },
            confirmFromDlg() {
                if (this.confirmDlgType === 'cancel') {
                    this.$emit('done')
                } else if (this.confirmDlgType === 'notifs') {
                    this.explicitNotifState = true;
                    this.subscription.enabled = true;
                } else if (this.confirmDlgType === 'delete') {
                    this.showLoading = true;
                    var p;
                    if (this.subscription.localId)
                        p = Promise.resolve().then(() => this.$cookies.remove("new-sub-stop"));
                    else
                        p = axios.delete('api/subscription/' + this.$store.state.user.cnxUserId + '/' + this.subscription.subscriptionId);
                    p.then(() => {
                        this.$emit('done');
                    }).catch(e => {
                        console.log(e);
                        alert("Could not delete your subscription. Please try again.");
                    }).finally(() => {
                        this.showLoading = false;
                    })
                    this.timetableLoaded = false;
                }
                this.showConfirm = false;
            },
            dirtyTripScheduleTag() {
                this.tripInfo = null;
                this.subscription.routePositionEnd = null;
                this.subscription.routePositionBegin = null;
                this.subscription.tripScheduleTag = null;
                this.subscription.warningTime = null;
                this.hasSubscribedTrips = false;
            },
            dirtyDest() {
                this.tripInfo = null;
                this.subscription.routePositionEnd = null;
                this.subscription.routePositionBegin = null;
                this.subscription.tripScheduleTag = null;
                this.subscription.warningTime = null;
                this.hasSubscribedTrips = false;
                this.subscription.notBefore = null;
                this.subscription.notAfter = null;
                this.subscription.weekdayNames = [];
                this.dateData.start = null;
                this.dateData.end = null;   
                this.getTimetable();
                this.valid.dest = true;
            },
            dirtyRouteNo() {
                this.tripInfo = null;
                this.subscription.routePositionEnd = null;
                this.subscription.routePositionBegin = null;
                this.subscription.tripScheduleTag = null;
                this.subscription.warningTime = null;
                this.subscription.destination = null;
                this.hasSubscribedTrips = false;
                this.valid.dest = false;
            },
            notificationToggle(e) {
                if (e) {
                    this.$refs.notificationToggleEl.reset();
                    this.subscription.enabled = false;
                    this.makeConfirmDialog('notifs');
                } else {
                    this.explicitNotifState = true;
                }
            },
            saveAndExit() {
                this.showLoading = true;
                var p;
                var o = Object.assign({}, this.subscription);
                if (this.notifTimeType === 0) {
                    o.tripScheduleTag = null;
                    o.routePositionBegin = null;
                    o.routePositionEnd = null;
                } else if (this.notifTimeType === 1) {
                    o.notBefore = null;
                    o.notAfter = null;
                }
                var contactTypeName = this.contactTypes[this.contactTypeModel].name;
                o.contactAddressId = this.contactAddresses[contactTypeName][this.contactModels[contactTypeName]].contactAddressId;
                //debugger;
                if (this.subscription.localId)
                    p = axios.post('api/subscription/' + this.$store.state.user.cnxUserId, o)
                        .then(() => this.$cookies.remove("new-sub-stop"))
                else
                    p = axios.put('api/subscription/' + this.$store.state.user.cnxUserId, o);
                p.then(() => {
                    console.log(o.contactAddressId)
                    //debugger;
                    this.$emit('done');
                }).catch(e => {
                    console.log(e);
                    alert("Could not save your subscription. Please try again.");
                }).finally(() => {
                    this.showLoading = false;
                })
                this.timetableLoaded = false;
            },
            cancel() {
                if (this.containsObject(this.model, this.subscription))
                    this.$emit('done');
                else
                    this.makeConfirmDialog('cancel');
                this.timetableLoaded = false;
            },
            blurFromRef(ref) {
                var el = this.$refs[ref].$el;
                el.querySelector(':focus').blur();
            },
            redraw(el) {
                el.style.transform = "rotateZ(0deg)";
                var _ = el.offsetHeight;
                el.style.transform = null;
                return _;
            },
        },
        created() {
            this.initialise(this.model);
        },
        watch: {
            model(n) {
                this.initialise(n);
            },
        }
    };
</script>
<style scoped>
    > > > .v-input--switch .theme--light.v-label {
        color: black;
        font-size: 1.1em;
    }

    > > > .v-input--switch.v-input--is-disabled .theme--light.v-label {
        color: rgba(0,0,0,.38)
    }

    > > > .v-btn-toggle .v-btn--text.theme--light:not(.v-btn--active) {
        color: black !important;
    }

    > > > .v-btn-toggle .v-btn--text.theme--light.v-btn--disabled {
        color: rgba(0,0,0,.26) !important;
    }
    .centered-input >>> input{
        text-align: center
    }
</style>
